export const INPUT_PLACEHOLDER = "Tap to change!";
